import { useViewport } from "@xyflow/react";
import cn from "classnames";
import IsometricDots from "~/components/Playground/Background/IsometricDots";

export default function Background() {
  const { x: xPos, y: yPos, zoom } = useViewport();

  return (
    <svg
      aria-hidden={true}
      className={cn([
        "react-flow__background",
        ["absolute", "w-full", "h-full", "inset-0"],
        "bg-slate-50",
      ])}
    >
      <pattern
        id="pattern"
        data-testid="pattern"
        x={xPos / zoom}
        y={yPos / zoom}
        width={48}
        height={48}
        patternUnits="userSpaceOnUse"
        patternTransform={`scale(${zoom})`}
      >
        <IsometricDots />
      </pattern>
      <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern)" />
    </svg>
  );
}
